import { InfoOutlined } from '@finn/design-system/icons/info-outlined';
import { cn, parseToHtml } from '@finn/ui-utils';

type Props = {
  title: string;
  description: string;
};

const InfoBox = ({ title, description }: Props) => {
  return (
    <div
      className={cn(
        'flex h-full flex-col border border-solid border-pearl p-10'
      )}
    >
      <div className="w-full">
        <InfoOutlined className="min-h-7 min-w-7" />
      </div>
      <div className="w-full">
        <h4 className="mb-2 mobile-t4-semibold md:web-t4-semibold">
          {parseToHtml(title)}
        </h4>
      </div>
      <div className="w-full">{parseToHtml(description)}</div>
    </div>
  );
};

export default InfoBox;
